module.exports = __webpack_public_path__ + "img/icon-arrow-right-light-no-outline.25e62469.svg";